import request from '@/utils/request'
import Setting from '../settings'
var {
  interFaceDomain
} = Setting
// var interFaceDomains = "https://www.fastmock.site/mock/86622f1d2ec0b42d478f46b6eddac68b/front"
// 获取任务统计
export function billList(data) {
  return request({
    url: interFaceDomain + '/front/statement/getFrontStatementList',
    method: 'post',
    data
  })
}
// 获取预估详情
export function statusList(params) {
  return request({
    url: interFaceDomain + '/front/statement/getFrontSettlementStatusList',
    method: 'get',
    params
  })
}
//获取待结算账单列表
export function getUnApplyList(data) {
  return request({
    url: interFaceDomain + '/front/traffic/notAppliedIntervals',
    method: 'post',
    data
  })
}
// 获取已申请结算列表
export function getAppliedList(data) {
  return request({
    url: interFaceDomain + '/front/traffic/billList',
    method: 'post',
    data
  })
}
// 获取账单详情
export function getBillAppliedDetail(params) {
  return request({
    url: interFaceDomain + '/front/traffic/billDetail',
    method: 'get',
    params
  })
}
// 获取已申请结算账单详情
export function getBillDetail(params) {
  return request({
    url: interFaceDomain + '/front/traffic/billDetail',
    method: 'get',
    params
  })
}
// 获取主体信息
export function getAduserInfo(params) {
  return request({
    url: interFaceDomain + '/front/traffic/subject/list',
    method: 'get',
    params
  })
}
// 前台流量主申请结算
export function applySettlement(data) {
  return request({
    url: interFaceDomain + "/front/traffic/applyBill",
    method: "post",
    data
  })
}
// 获取选定的结算区间的信息  (申请结算页面数据接口)
export function getSettlementInfo(params) {
  return request({
    url: interFaceDomain + "/front/traffic/listIntervals",
    method: 'get',
    params
  })
}
// 获取账单所有数据信息
export function getBillDetailInfo(params) {
  return request({
    url: interFaceDomain + "/front/traffic/billDetailInfo",
    method: 'get',
    params
  })

}